import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo(({ direction, ...params }) => (
  <GenericIcon {...params} transform={`scale(1, ${direction === 'down' ? -1 : 1})`}>
    <path d="M3 17L9 11L13 15L21 7" />
    <path d="M14 7H21V14" />
  </GenericIcon>
));
